import React, { useState, useEffect } from 'react';
import ExploreAllCard from "./Explorecard";
import ModalImage from "./ModalImage";
import {
  Men_Shirts,
  Men_Trousers,
  Women_Bottoms,
  Women_Sets,
  Women_Shirts_Tops,
} from "../data/products";

const ExploreAll = () => {
  const getUniqueById = (arr) => [
    ...new Map(arr.map((item) => [item.id, item])).values(),
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleOpenModal = (id, allItems) => {
    const filtered = allItems.filter((item) => item.id === id);
    setSelectedImages(filtered);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <div className="content">
      <h2 className="Explore-h2">Our Collections</h2>

      <section className="categories section-offwhite">
        <div className="categories__list">
          {getUniqueById(Men_Shirts).map((ExploreAll) => (
            <ExploreAllCard
              key={`men-shirts-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Men_Shirts}
              onImageClick={handleOpenModal}
            />
          ))}

          {getUniqueById(Men_Trousers).map((ExploreAll) => (
            <ExploreAllCard
              key={`men-shirts-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Men_Shirts}
              onImageClick={handleOpenModal}
            />
          ))}

          {getUniqueById(Women_Bottoms).map((ExploreAll) => (
            <ExploreAllCard
              key={`women-bottoms-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Women_Bottoms}
              onImageClick={handleOpenModal}
            />
          ))}

          {getUniqueById(Women_Sets).map((ExploreAll) => (
            <ExploreAllCard
              key={`women-sets-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Women_Sets}
              onImageClick={handleOpenModal}
            />
          ))}

          {getUniqueById(Women_Shirts_Tops).map((ExploreAll) => (
            <ExploreAllCard
              key={`women-tops-${ExploreAll.id}`}
              ExploreAll={ExploreAll}
              allItems={Women_Shirts_Tops}
              onImageClick={handleOpenModal}
            />
          ))}
        </div>
      </section>

      {isModalOpen && (
        <ModalImage
          images={selectedImages}
          handleCloseModal={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ExploreAll;